module.exports = __webpack_public_path__ + "img/home_head_md_bg.2fc5a7fd.png";